// extracted by mini-css-extract-plugin
export default {"body":"body-d5bx6scl"};